import React from 'react';
const links = ['Termini e condizioni', 'Informativa sulla privacy', 'Politica di rimborso', 'Contatti'];
export function Footer() {
  return <footer className="w-full bg-ink px-5 pb-16 pt-16" data-id="element-95" data-mp="3ggu1qsai619z">
      <div className="mx-auto max-w-5xl text-center" data-id="element-96" data-mp="32oe11y52qfc8">
        <p className="font-display text-3xl leading-none text-white" data-id="element-97" data-mp="32lrkxa44arie">
          Inglese Pronto<span className="text-brand" data-id="element-98" data-mp="36pzeplpfmxnh">™</span>
        </p>
        <p className="mt-4 font-display text-lg tracking-[0.06em] text-volt" data-id="element-99" data-mp="3ueimm04kl8f1">
          Pianifica meno. Insegna meglio.
        </p>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-white/50" data-id="element-100" data-mp="387czflhuzc3">
          Materiale di Inglese pronto all’uso, dal livello A1 al C2, allineato
          alle Indicazioni Nazionali e al QCER.
        </p>
        <nav aria-label="Pié di pagina" data-id="element-101" data-mp="3qfjgwdb0l7mj">
          <ul className="mt-9 flex flex-wrap items-center justify-center gap-x-7 gap-y-3 text-sm font-semibold text-white/60" data-id="element-102" data-mp="29ynmjnzj5bfl">
            {links.map(link => <li key={link} data-id="element-103" data-mp="2ezl5i2sd69i5">
                <a href="#offer" className="transition-colors duration-150 ease-out hover:text-volt" data-id="element-104" data-mp="3l9k7bh9idvfe">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-10 max-w-2xl border-t border-white/10 pt-8 text-xs leading-relaxed text-white/40" data-id="element-105" data-mp="3v7q63q00qlg1">
          © 2026 Inglese Pronto™. Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}